export default __webpack_public_path__ + "static/media/ELEMENTOS DO BG_apple.edfe8dc9.png";